(function () {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobileLayout = window.matchMedia('(max-width: 767px)');

  function copyCard(source) {
    const card = source.cloneNode(true);
    card.classList.remove('t4s-col-item', 't4s-collection-carousel', 'is-selected');
    card.classList.add('dk-discovery-mobile-card');
    card.removeAttribute('id');
    card.removeAttribute('style');
    card.removeAttribute('data-select-flickity');
    card.removeAttribute('aria-hidden');

    card.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
    card.querySelectorAll('[tabindex="-1"]').forEach((element) => element.removeAttribute('tabindex'));
    card.querySelectorAll('[data-dk-lazy-video]').forEach((video) => {
      delete video.dataset.dkLazyVideoReady;
      delete video.dataset.dkVideoVisible;
      delete video.dataset.dkVideoLoaded;
    });
    return card;
  }

  function prepareMobileDeck(section) {
    if (!mobileLayout.matches) return;
    if (section.dataset.dkDiscoveryPagerReady === 'true') return;

    const source = section.querySelector('.t4s-list-collections');
    if (!source) return;

    let sourceCards = Array.from(source.querySelectorAll('.flickityt4s-slider > .t4s-collection-carousel:not(.is-cloned)'));
    if (!sourceCards.length) {
      sourceCards = Array.from(source.querySelectorAll(':scope > .t4s-collection-carousel'));
    }
    if (!sourceCards.length) return;

    section.dataset.dkDiscoveryPagerReady = 'true';

    const isArabic = (document.documentElement.lang || '').toLowerCase().startsWith('ar');
    const pageDirection = document.documentElement.dir || (isArabic ? 'rtl' : 'ltr');
    const isRtl = pageDirection === 'rtl';
    const carouselLabel = section.dataset.dkDiscoveryCarouselLabel || 'Discovery choices';
    const swipeMoreLabel = section.dataset.dkDiscoverySwipeMore || 'Swipe for more choices';
    const swipeBackLabel = section.dataset.dkDiscoverySwipeBack || 'Swipe to go back';
    const showGroupLabel = section.dataset.dkDiscoveryShowGroup || 'Show group';
    const pageCount = Math.ceil(sourceCards.length / 4);
    const deck = document.createElement('div');
    const pages = document.createElement('div');
    const nav = document.createElement('div');
    const hint = document.createElement('span');
    const dots = document.createElement('span');
    const status = document.createElement('span');

    deck.className = 'dk-discovery-mobile-deck';
    pages.className = 'dk-discovery-mobile-pages';
    pages.dir = pageDirection;
    pages.setAttribute('aria-roledescription', 'carousel');
    pages.setAttribute('aria-label', carouselLabel);
    nav.className = 'dk-discovery-mobile-nav';
    hint.className = 'dk-discovery-mobile-hint';
    hint.textContent = swipeMoreLabel;
    dots.className = 'dk-discovery-mobile-dots';
    status.className = 'dk-discovery-mobile-status';

    for (let pageIndex = 0; pageIndex < pageCount; pageIndex += 1) {
      const page = document.createElement('div');
      page.className = 'dk-discovery-mobile-page';
      page.dir = pageDirection;
      page.setAttribute('role', 'group');
      page.setAttribute('aria-label', `${pageIndex + 1} / ${pageCount}`);

      sourceCards.slice(pageIndex * 4, pageIndex * 4 + 4).forEach((sourceCard) => {
        page.appendChild(copyCard(sourceCard));
      });
      pages.appendChild(page);

      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'dk-discovery-mobile-dot';
      dot.setAttribute('aria-label', `${showGroupLabel} ${pageIndex + 1}`);
      dot.addEventListener('click', () => {
        const directionMultiplier = isRtl ? -1 : 1;
        pages.scrollTo({ left: directionMultiplier * pageIndex * pages.clientWidth, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      });
      dots.appendChild(dot);
    }

    function updateNavigation() {
      const currentPage = Math.max(0, Math.min(pageCount - 1, Math.round(Math.abs(pages.scrollLeft) / Math.max(1, pages.clientWidth))));
      status.textContent = `${currentPage + 1} / ${pageCount}`;
      hint.textContent = currentPage === 0 ? swipeMoreLabel : swipeBackLabel;
      dots.querySelectorAll('.dk-discovery-mobile-dot').forEach((dot, index) => {
        dot.setAttribute('aria-current', index === currentPage ? 'true' : 'false');
      });
    }

    let scrollFrame;
    pages.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(updateNavigation);
    }, { passive: true });

    nav.append(hint, dots, status);
    deck.append(pages, nav);
    source.insertAdjacentElement('afterend', deck);
    updateNavigation();
    if (window.DkhounLazyVideo) window.DkhounLazyVideo.init(deck);
  }

  function init(scope) {
    scope.querySelectorAll('.dk-discovery-mobile-paged').forEach(prepareMobileDeck);
  }

  init(document);
  const handleMobileLayout = (event) => {
    if (event.matches) init(document);
  };
  if (mobileLayout.addEventListener) mobileLayout.addEventListener('change', handleMobileLayout);
  else mobileLayout.addListener(handleMobileLayout);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
}());
